import { render, staticRenderFns } from "./modifyDetails.vue?vue&type=template&id=796ab8a2&scoped=true&"
import script from "./modifyDetails.vue?vue&type=script&lang=js&"
export * from "./modifyDetails.vue?vue&type=script&lang=js&"
import style0 from "./modifyDetails.vue?vue&type=style&index=0&id=796ab8a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ab8a2",
  null
  
)

export default component.exports